import { useEffect, useRef } from 'react';

const ROOT_MARGIN = '200px';

const useInfiniteScroll = ({ hasMore, isLoading, onLoadMore }) => {
  const onLoadMoreRef = useRef(onLoadMore);
  const sentinelRef = useRef(null);

  onLoadMoreRef.current = onLoadMore;

  useEffect(() => {
    if (!hasMore || isLoading) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          observer.disconnect();
          onLoadMoreRef.current();
        }
      },
      { rootMargin: ROOT_MARGIN }
    );

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => observer.disconnect();
  }, [hasMore, isLoading]);

  return sentinelRef;
};

export default useInfiniteScroll;
